<!-- TEMPLATE -->
<template>
  <div class="toolbar">
    <dean-button-group>
      <dean-button
        v-for="item in buttons"
        :key="item.id"
        :id="item.id"
        :theme="item.theme"
        :icon="item.icon" 
        :group-button="true" 
        :mobile-collapse="true"
        :mobile-button="item.mobileButton"
        :disabled="item.disabled"
        @dean-button-click="clicked(item.id)">
        {{ item.title }}
      </dean-button>
    </dean-button-group>
    <div class="toolbar-title">
      <p>{{ title }}</p>
      <p>{{ subTitle }}</p>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanButton from './deanButton.vue';
import deanButtonGroup from './deanButtonGroup.vue';

@Component({
  components: {
    deanButton,
    deanButtonGroup
  }
})
export default class deanToolbar extends Vue {
  // PROPS
  @Prop() title!: string;
  @Prop() subTitle!: string;
  @Prop() buttons!: Array<any>;

  // METHOD
  clicked(id: string) {
    this.$emit('button-click', id);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
/* Import */
@import '../scss/vars';

.toolbar {
  @include display-flex();
  position: relative;
  justify-content: space-between;
  align-items: center; 
  width: 100%;
  padding: 10px 10px 10px 0px;
  background: #d70019;
  .toolbar-title {
    @include display-flex();
    justify-content: flex-end;
    word-break: break-all;
    text-align: left;
    text-transform: uppercase;
    font-style: italic;
    font-weight: 500;
    font-size: $font-heading-small;
    color: white;
    padding-left: 20px;
    height: 100%;
    p {
      display: inline;
      padding: 0 0 0 5px;
      &:first-child {
        font-weight: 700;
      }
    }
    @media #{$small-only} {
      display: none;
    }
  }
  &:after {
    position: absolute;
    bottom: 0px;
    right: 0px;
    content: '';
    min-width: 100px;
    min-height: 5px;
    background: var(--color-secondary, $color-secondary);
  }
}
</style>
